export enum FeatureToggle {
  storeConfiguration = 'rt_store_configuration',
  dmsDraftTableEnabled = 'rt_dms_draft_table_enabled',
  checkoutLoyaltyStepAnchor = 'rt_checkout_loyalty_step_anchor',
}
